/**
 * API Configuration
 *
 * Centralized configuration for API client base URLs.
 * Uses environment variables for flexibility across environments.
 */

export const API_CONFIG = {
  /**
   * Base URL for API endpoints
   * - Development: Empty string (uses Vite proxy)
   * - Production: Set via VITE_API_BASE_URL environment variable
   */
  baseUrl: import.meta.env.VITE_API_BASE_URL || '',
} as const;

/**
 * Helper function to get the API base URL
 * Can be extended for more complex URL logic if needed
 */
export const getApiBaseUrl = (): string => {
  return API_CONFIG.baseUrl;
};
